import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CommonInput from '@/components/CommonInput.vue';
import CurrencyValue from '@/components/CurrencyValue.vue';
import PersonalizeToggle from '@/components/PersonalizeToggle.vue';
import FormatUtils from '@/utils/format_utils';
import { Icons } from '@/font-awesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditValueComponent',
  props: {
    basketValue: { type: String, required: true },
    suportingText: { type: String, required: false }
  },
  emits: ["update:basketValue", "reset:basketValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit;

__expose({
  resetHasAlteration: () => {
    hasAlterationValue.value = false;
  },
  getHasAlteration: () => {
    return hasAlterationValue;
  }
});

const hasAlterationValue = ref(false);



const __returned__ = { emit, hasAlterationValue, CommonInput, CurrencyValue, PersonalizeToggle, get FormatUtils() { return FormatUtils }, get Icons() { return Icons } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})